(function () {
  var ERROR_DURATION_MS = 10000;

  
  function getFlashOverlay() {
    var overlay = document.querySelector('.puc-screen-flash');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'puc-screen-flash';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  var flashTimeout;
  function triggerScreenFlash() {
    var overlay = getFlashOverlay();
    overlay.classList.remove('is-flashing');
    void overlay.offsetWidth;
    overlay.classList.add('is-flashing');

    clearTimeout(flashTimeout);
    flashTimeout = setTimeout(function () {
      overlay.classList.remove('is-flashing');
    }, 700);
  }

  var screenShakeTimeout;
  function triggerScreenShake() {
    var target = document.body;
    if (!target) return;
    target.classList.remove('puc-screen-shake');
    void target.offsetWidth;
    target.classList.add('puc-screen-shake');

    clearTimeout(screenShakeTimeout);
    screenShakeTimeout = setTimeout(function () {
      target.classList.remove('puc-screen-shake');
    }, 600);
  }

  function triggerVibration() {
    
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate([120, 60, 120]);
    }
  }

  function initSection(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root || root.dataset.pucInitialized === 'true') return;
    root.dataset.pucInitialized = 'true';

    var totalWatts = parseFloat(root.dataset.totalWatts) || 1;
    var needle = root.querySelector('[data-puc-needle]');

   
    var errorBanners = Array.prototype.slice.call(root.querySelectorAll('[data-puc-error]'));

    var deviceGroups = {};
    Array.prototype.slice.call(root.querySelectorAll('[data-puc-device]')).forEach(function (row) {
      var id = row.dataset.deviceId;
      if (!id) return;
      if (!deviceGroups[id]) {
        deviceGroups[id] = { watt: parseFloat(row.dataset.watt) || 0, rows: [] };
      }
      deviceGroups[id].rows.push(row);
    });

    function getDeviceName(row) {
      var nameEl = row.querySelector('.puc-device-name');
      return nameEl ? nameEl.textContent.trim() : '';
    }

    function compareDeviceNames(a, b) {
      return getDeviceName(a).localeCompare(getDeviceName(b), undefined, {
        sensitivity: 'base',
        numeric: true,
      });
    }

    
    function sortRowsWithin(container) {
      if (!container) return;
      var rows = Array.prototype.filter.call(container.children, function (el) {
        return el.matches && el.matches('[data-puc-device]');
      });
      rows.sort(compareDeviceNames);
      rows.forEach(function (row) { container.appendChild(row); });
    }

    
    function sortDesktopColumns() {
      var leftCol = root.querySelector('[data-puc-column="left"]');
      var rightCol = root.querySelector('[data-puc-column="right"]');
      if (!leftCol || !rightCol) return;

      var rows = Array.prototype.slice
        .call(leftCol.querySelectorAll('[data-puc-device]'))
        .concat(Array.prototype.slice.call(rightCol.querySelectorAll('[data-puc-device]')));

      rows.sort(compareDeviceNames);

     
      var splitAt = Math.ceil(rows.length / 2);
      rows.forEach(function (row, index) {
        (index < splitAt ? leftCol : rightCol).appendChild(row);
      });
    }

    
    sortDesktopColumns();
    root.querySelectorAll('.puc-category-body').forEach(sortRowsWithin);

    function getRowFor(toggle) {
      return toggle.closest('[data-puc-device]');
    }

    function isDeviceChecked(id) {
      var group = deviceGroups[id];
      if (!group || !group.rows.length) return false;
      var toggle = group.rows[0].querySelector('[data-puc-toggle]');
      return !!(toggle && toggle.checked);
    }

    function setDeviceChecked(id, checked) {
      var group = deviceGroups[id];
      if (!group) return;
      group.rows.forEach(function (row) {
        var toggle = row.querySelector('[data-puc-toggle]');
        if (toggle) toggle.checked = checked;
      });
    }

    
    function resetAllDevices() {
      Object.keys(deviceGroups).forEach(function (id) {
        setDeviceChecked(id, false);
      });
    }

    function currentSumWatts(excludeId, forceState) {
      var sum = 0;
      Object.keys(deviceGroups).forEach(function (id) {
        var isOn = isDeviceChecked(id);
        if (excludeId && id === excludeId) isOn = forceState;
        if (isOn) sum += deviceGroups[id].watt;
      });
      return sum;
    }

    function updateCategoryTotals() {
      root.querySelectorAll('[data-puc-category]').forEach(function (categoryEl) {
        var sum = 0;
        categoryEl.querySelectorAll('[data-puc-device]').forEach(function (row) {
          var toggle = row.querySelector('[data-puc-toggle]');
          if (toggle && toggle.checked) {
            sum += parseFloat(row.dataset.watt) || 0;
          }
        });
        var wattEl = categoryEl.querySelector('[data-puc-category-watt]');
        if (wattEl) {
          wattEl.textContent = formatWatts(sum) + ' Watts active';
        }
      });
    }

    function getVisibleBanner() {
      for (var i = 0; i < errorBanners.length; i++) {
        
        if (errorBanners[i].offsetParent !== null) return errorBanners[i];
      }
      return errorBanners[0] || null;
    }

    function showError(message) {
      if (!errorBanners.length) return;

      errorBanners.forEach(function (banner) {
        var textEl = banner.querySelector('[data-puc-error-text]');
        if (textEl) textEl.textContent = message;
        banner.hidden = false;
      });

      var visible = getVisibleBanner();
      if (visible) {
       
        requestAnimationFrame(function () {
          visible.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      clearTimeout(root._pucErrorTimeout);
      root._pucErrorTimeout = setTimeout(function () {
        errorBanners.forEach(function (banner) { banner.hidden = true; });
      }, ERROR_DURATION_MS);
    }

    function hideError() {
      errorBanners.forEach(function (banner) { banner.hidden = true; });
    }

    function triggerRowShake(row) {
      if (!row) return;
      row.classList.remove('puc-shake');
      void row.offsetWidth;
      row.classList.add('puc-shake');

      clearTimeout(root._pucShakeTimeout);
      root._pucShakeTimeout = setTimeout(function () {
        row.classList.remove('puc-shake');
      }, 500);
    }

    function formatWatts(watts) {
      return Math.round(watts).toLocaleString();
    }

    function formatPercent(percent) {
      var pct = percent * 100;
      if (pct > 0 && pct < 1) {
        return pct.toFixed(1) + '%';
      }
      return Math.round(pct) + '%';
    }

    function render() {
      var watts = currentSumWatts();
      var percent = Math.max(0, Math.min(1, watts / totalWatts));
      var angle = -90 + percent * 180;

      if (needle) needle.style.transform = 'rotate(' + angle + 'deg)';

      root.querySelectorAll('[data-puc-current-watts]').forEach(function (el) {
        el.textContent = formatWatts(watts);
      });
      root.querySelectorAll('[data-puc-current-kw-sub]').forEach(function (el) {
        el.textContent = formatWatts(watts);
      });
      root.querySelectorAll('[data-puc-percent]').forEach(function (el) {
        el.textContent = formatPercent(percent);
      });
      root.querySelectorAll('[data-puc-progress-fill]').forEach(function (el) {
        var widthPct = watts > 0 ? Math.max(percent * 100, 1.5) : 0;
        el.style.width = widthPct + '%';
        el.classList.toggle('is-over', watts > totalWatts);
      });

      updateCategoryTotals();
    }

    root.addEventListener('change', function (event) {
      var toggle = event.target.closest('[data-puc-toggle]');
      if (!toggle) return;

      var row = getRowFor(toggle);
      var id = row ? row.dataset.deviceId : null;
      if (!id) return;

      var checked = toggle.checked;
      setDeviceChecked(id, checked);

      if (checked) {
        var prospective = currentSumWatts(id, true);
        if (prospective > totalWatts) {
          var nameEl = row.querySelector('.puc-device-name');
          var name = nameEl ? nameEl.textContent : 'This device';

          
          resetAllDevices();

          showError(
            name +
              ' would push usage above your ' +
              formatWatts(totalWatts) +
              ' Watts budget. All devices have been switched off — please start again.'
          );

          triggerScreenShake();
          triggerScreenFlash();
          triggerRowShake(row);
          triggerVibration();

          row.classList.add('is-disabled-target');
          setTimeout(function () { row.classList.remove('is-disabled-target'); }, 900);

          render();
          return;
        }
      }

      hideError();
      render();
    });

    render();
  }

  window.PowerUsageCalculator = {
    init: initSection
  };

  document.querySelectorAll('.puc-section').forEach(function (el) {
    initSection(el.id);
  });
})();
